import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../pages/Admin/Login";
import Register from "../pages/Admin/Register";
import Dashboard from "../pages/Admin/Dashboard";
import SuperAdminDashboard from "../pages/Admin/SuperAdminDashboard";
import EventDetails from "../pages/User/EventDetails";
import Registration from "../pages/User/Registration";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import ProtectedRoute from "../utils/ProtectedRoute";
import ManageEvents from "../pages/Admin/ManageEvents";
import ViewRegistrations from "../pages/Admin/ViewRegistrations";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route
      path="/dashboard"
      element={<ProtectedRoute element={<Dashboard />} />}
    />
    <Route
      path="/superadmindashboard"
      element={<ProtectedRoute element={<SuperAdminDashboard />} />}
    />
    <Route
      path="/events"
      element={<ProtectedRoute element={<ManageEvents />} />}
    />
    <Route path="/e/:eventslug" element={<EventDetails />} />
    <Route path="/r/:eventslug" element={<Registration />} />
    <Route path="events/:eventslug" element={<ViewRegistrations />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
